import { ChevronDown, ChevronUp } from 'lucide-react';
import { useRef } from 'react';
import { cn } from '../../lib/utils';
import { fieldWrapper, fieldWrapperInput } from './field-surface';

interface NumberInputProps extends Omit<React.ComponentProps<'input'>, 'type'> {
	label?: string;
}

export function NumberInput({ className, ...props }: NumberInputProps) {
	const ref = useRef<HTMLInputElement>(null);

	const step = (direction: 'up' | 'down') => {
		if (!ref.current) return;
		if (direction === 'up') ref.current.stepUp();
		else ref.current.stepDown();
		ref.current.dispatchEvent(new Event('input', { bubbles: true }));
		ref.current.dispatchEvent(new Event('change', { bubbles: true }));
	};

	return (
		<div className={cn(fieldWrapper, className)}>
			<input
				ref={ref}
				type="number"
				data-slot="input"
				className={fieldWrapperInput}
				{...props}
			/>
			<div className="flex w-6 shrink-0 flex-col border-l border-line-2">
				<button
					type="button"
					tabIndex={-1}
					onClick={() => step('up')}
					className="flex flex-1 cursor-pointer items-center justify-center text-text-4 transition-colors hover:bg-surface-hover hover:text-text-2"
				>
					<ChevronUp size={11} />
				</button>
				<div className="h-px bg-input" />
				<button
					type="button"
					tabIndex={-1}
					onClick={() => step('down')}
					className="flex flex-1 cursor-pointer items-center justify-center text-text-4 transition-colors hover:bg-surface-hover hover:text-text-2"
				>
					<ChevronDown size={11} />
				</button>
			</div>
		</div>
	);
}
